export default "__VITE_ASSET__C108C5lv__"